import { render } from "./ReuseMinCapBadge.vue?vue&type=template&id=3916c348&ts=true"
import script from "./ReuseMinCapBadge.vue?vue&type=script&lang=ts"
export * from "./ReuseMinCapBadge.vue?vue&type=script&lang=ts"

import "./ReuseMinCapBadge.vue?vue&type=style&index=0&id=3916c348&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__